import React, { useEffect, useState } from 'react'
import globalNotification from 'live/services/global-notification'
import ChangeLog from './changeLog/ChangeLog'
import UpdateAsset from './updateAsset/UpdateAsset'

interface Props {
    selected: {
        asset: {
            id: string
            name: string
        }
    }
}

export const AssetMetadataForm: React.FC<Props> = ({ selected }: Props) => {
    const [interventionData, setInterventionData] = useState<Changes>()
    const [attributesData, setAttributesData] = useState<Changes>()

    useEffect(() => {
        const url = `services/plugin-asset-metadata/changeLog/attributes?wellboreId=${selected.asset.id}`
        fetch(url)
            .then(result => {
                if (result.ok) {
                    return result.json()
                } else {
                    throw new Error()
                }
            })

            .then(json => setAttributesData(json))
            .catch(e => globalNotification.error(`An error occurred when fetching changeLog data: ${e.message}`))
    }, [selected.asset.id])

    useEffect(() => {
        const url = `services/plugin-asset-metadata/changeLog/intervention?wellboreId=${selected.asset.id}`
        fetch(url)
            .then(result => {
                if (result.ok) {
                    return result.json()
                } else {
                    throw new Error()
                }
            })

            .then(json => setInterventionData(json))
            .catch(e => globalNotification.error(`An error occurred when fetching changeLog data: ${e.message}`))
    }, [selected.asset.id])

    return (
        <div>
            <UpdateAsset selected={selected} />
            {attributesData && <ChangeLog data={attributesData} selected={selected} type={'attributes'} />}
            {interventionData && <ChangeLog data={interventionData} selected={selected} type={'intervention'} />}
        </div>
    )
}
